{
    "name": "client-app",
    "version": "1.2.9",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint",
        "pretty": "prettier --write \"./**/*.{js,jsx,mjs,cjs,ts,tsx,json}\"",
        "stats": "ng build --stats-json",
        "analyse": "esbuild-visualizer --open=true --metadata dist/stats.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.2.6",
        "@angular/cdk": "^19.2.9",
        "@angular/common": "^19.2.6",
        "@angular/compiler": "^19.2.6",
        "@angular/core": "^19.2.6",
        "@angular/forms": "^19.2.6",
        "@angular/material": "^19.2.9",
        "@angular/platform-browser": "^19.2.6",
        "@angular/platform-browser-dynamic": "^19.2.6",
        "@angular/router": "^19.2.6",
        "@fortawesome/angular-fontawesome": "^1.0.0",
        "@fortawesome/fontawesome-svg-core": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@ngx-translate/core": "^16.0.4",
        "@ngx-translate/http-loader": "^16.0.1",
        "@ngxmc/datetime-picker": "^19.1.0",
        "guid-typescript": "^1.0.9",
        "hammerjs": "^2.0.8",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "prettier": "^3.5.3",
        "rxjs": "^7.8.2",
        "tslib": "^2.8.1",
        "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.7",
        "@angular-eslint/builder": "^19.3.0",
        "@angular-eslint/eslint-plugin": "^19.3.0",
        "@angular-eslint/eslint-plugin-template": "^19.3.0",
        "@angular-eslint/schematics": "^19.3.0",
        "@angular-eslint/template-parser": "^19.3.0",
        "@angular/cli": "^19.2.7",
        "@angular/compiler-cli": "^19.2.6",
        "@types/jasmine": "^5.1.7",
        "@types/node": "^22.14.1",
        "@typescript-eslint/eslint-plugin": "^8.29.1",
        "@typescript-eslint/parser": "^8.29.1",
        "esbuild-visualizer": "^0.7.0",
        "eslint": "^9.24.0",
        "jasmine-core": "^5.6.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "^3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.1.0",
        "typescript": "^5.8.3"
    }
}
